import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function (theme) { return ({
    mainImg: {
        cursor: "pointer",
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .st1": {
            fill: "#fff",
        },
    },
    mobileImg: {
        cursor: "pointer",
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .st0": {
            fill: "#fff",
        },
    },
    list: {
        padding: theme.spacing(0),
    },
    container: {
        transition: "width ease 0.3s !important",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
    },
}); });
